export default __webpack_public_path__ + "static/media/downtime.30641140.svg";